// extracted by mini-css-extract-plugin
export var imageWrapper = "products-module--imageWrapper--1aIwN";